<template>
  <div>
    <InnerHeader
      :cover="require('../../assets/img/sustainability/cover.jpg')"
      :bgColor="'#5EAD43'"
      :links="links"
    />
    <Sustainability v-if="!$route.query.page"/>
    <Environment v-else-if="$route.query.page === 'environment'"/>
    <HealthAndSafety v-else-if="$route.query.page === 'health-and-safety'"/>
    <SocialResponsibility v-else-if="$route.query.page === 'social-responsibility'"/>
    <Gdpr v-else-if="$route.query.page === 'gdpr'"/>
    <Reporting v-else-if="$route.query.page === 'reporting'"/>
  </div>
</template>

<script>
import InnerHeader from '../shared/InnerHeader';
import Sustainability from './Sustainability';
import Environment from './Environment';
import HealthAndSafety from './HealthAndSafety';
import SocialResponsibility from './SocialResponsibility';
import Gdpr from './Gdpr';
import Reporting from './Reporting';
export default {
  components: {
    InnerHeader,
    Sustainability,
    Environment,
    HealthAndSafety,
    SocialResponsibility,
    Gdpr,
    Reporting
  },
  computed: {
    links() {
      return [
        {
          name: this.$t('nav4-1'),
          url: '/sustainability'
        },
        {
          name: this.$t('nav4-2'),
          url: '/sustainability?page=environment'
        },
        {
          name: this.$t('nav4-3'),
          url: '/sustainability?page=health-and-safety'
        },
        {
          name: this.$t('nav4-4'),
          url: '/sustainability?page=social-responsibility'
        },
        {
          name: this.$t('nav4-5'),
          url: '/sustainability?page=gdpr'
        },
        {
          name: this.$t('nav4-6'),
          url: '/sustainability?page=reporting'
        }
      ];
    }
  },
  mounted() {
    document.title = this.$t('title4');
  },
  destroyed() {
    document.title = this.$t('title0');
  }
};
</script>

<style>
</style>
